module.exports = __webpack_public_path__ + "r-v3/img/ml_81_00.c3dd9209.jpg";